export default "__VITE_ASSET__B2iy3xWp__"